import { Pipe, PipeTransform } from '@angular/core';
import * as jalaali from 'jalaali-js';

@Pipe({
  name: 'jalaliDate',
  standalone: true,
})
export class JalaliDatePipe implements PipeTransform {
  transform(value: string | Date | null, showTime = true): string {
    if (!value) return '-';

    const date = new Date(value);
    const jDate = jalaali.toJalaali(date);

    const year = jDate.jy;
    const month = jDate.jm.toString().padStart(2, '0');
    const day = jDate.jd.toString().padStart(2, '0');

    const formattedDate = `${year}/${month}/${day}`;

    if (!showTime) return formattedDate;

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${formattedDate} ${hours}:${minutes}`;
  }
}
